import React from 'react'
import { createHooksActions, createHooksSelectors } from 'src/helpers/redux'
import * as store from 'src/store/modules/twilio'
import type { IConnectPayload } from 'src/store/modules/twilio/actions'

store.injectStore()
export { store }

export const useTwilioNewSelect = createHooksSelectors<
  typeof store.selectors.selectors
>(store.selectors.selectors)

export const useTwilioNewActions = createHooksActions<typeof store.actions>(
  store.actions,
  store.selectors.communications
)

/** Starts an outgoing call; ignored while the previous connect is pending or a call is in progress */
export const useConnectCall = () => {
  const connect = useTwilioNewActions.connect()
  const { isPending } = useTwilioNewActions.connect.status()
  const { phase } = useTwilioNewSelect.call()

  return React.useCallback(
    (payload: IConnectPayload) => {
      if (isPending || phase !== 'idle') return
      connect(payload)
    },
    [connect, isPending, phase]
  )
}
